import { useState } from 'react';
import { useSoftwareKeyboard } from './hooks/useSoftwareKeyboard';
import { CenterPanel } from './ui/CenterPanel';
import { LeftPanel } from './ui/LeftPanel';
import { Mixer } from './ui/Mixer';
import { TopBar } from './ui/TopBar';

type MobileView = 'rack' | 'editor' | 'mixer';

function App() {
  useSoftwareKeyboard();
  // On narrow screens the three panels can't sit side by side, so a tab bar
  // shows one at a time (hidden on desktop via CSS).
  const [mobileView, setMobileView] = useState<MobileView>('editor');

  return (
    <div className="app">
      <TopBar />
      <nav className="mobile-tabs" aria-label="Panels">
        <button
          className={mobileView === 'rack' ? 'active' : ''}
          onClick={() => setMobileView('rack')}
        >
          Rack
        </button>
        <button
          className={mobileView === 'editor' ? 'active' : ''}
          onClick={() => setMobileView('editor')}
        >
          Editor
        </button>
        <button
          className={mobileView === 'mixer' ? 'active' : ''}
          onClick={() => setMobileView('mixer')}
        >
          Mixer
        </button>
      </nav>
      <div className={`body mobile-${mobileView}`}>
        <LeftPanel />
        <CenterPanel />
        <Mixer />
      </div>
      <footer className="statusbar">
        <span>Space = play/stop · A–K = play the selected channel · double-click a channel name to rename</span>
        <span className="dim">Zangle DAW — 100% client-side</span>
      </footer>
    </div>
  );
}

export default App;